module.exports = __webpack_public_path__ + "assets/img/mecha-btn-3b105950.png";